let api = process.env.VUE_APP_APIUSER
export default api
